import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import ProductNavigationV2 from "../../../components/ProductNavigationV2/ProductNavigationV2";
import SettingNavigation from "../../../components/SettingNavigation/SettingNavigation";
import ProductType, {
    ClientProductTypesList
} from "../../../../common/interfaces/enums/ProductType";
import { ProductSelectSettingsContainer } from "../../../containers/ProductsSelectSettingContainer/ProductsSelectSettingContainer";
import { QuoteGroupContext } from "../../../providers/RootContextProvider";
import { clearAllConfigsAPI } from "../../../api/endpoints/ApiQuotes";

interface IProductSelectPageContentMultiProductProps {
    initialProductsSelected: ProductType[];
}
const ProductSelectPageContentMultiProduct: React.FC<IProductSelectPageContentMultiProductProps> = (
    props
) => {
    const { selectors, actions } = useContext(QuoteGroupContext);

    const [selectedProducts, setSelectedProducts] = useState<ProductType[]>(
        props.initialProductsSelected
    );

    const history = useHistory();

    return (
        <React.Fragment>
            <ProductSelectSettingsContainer heading="Select the types of insurance you'd like to compare">
                <ProductNavigationV2
                    selectedProducts={selectedProducts}
                    setSelectedProducts={setSelectedProducts}
                />
            </ProductSelectSettingsContainer>
            <SettingNavigation
                onClickCallToAction={async () => {
                    const params = new URLSearchParams();

                    await clearAllConfigsAPI(selectors.getGroupId());
                    actions.clearQuoteResults();

                    selectedProducts.forEach((product) => {
                        params.append("product", product);
                    });

                    const startingProduct = ClientProductTypesList.find((s) =>
                        selectedProducts.includes(s)
                    );

                    if (startingProduct) {
                        history.push(
                            `/settings/wizard/${startingProduct}?${params.toString()}`
                        );
                    }
                }}
                isDisabledCallToAction={selectedProducts.length < 1}
                onClickBack={() => {
                    const paramBuilder = new URLSearchParams();
                    selectedProducts.forEach((s) => {
                        paramBuilder.append("product", s);
                    });
                    history.push(`/family?${paramBuilder.toString()}`);
                }}
                isEditing={false}
            />
        </React.Fragment>
    );
};

export default ProductSelectPageContentMultiProduct;
